/**
 * The structured data for the models is currently stored in a JSON file.
 */
import modelInfo from './modelsFinal.json';
import {Model, ModelInfo} from './types';

// TODO: On load, calculate some summary statistics we could use for visualization or filters.

export const MODEL_INFO = modelInfo as ModelInfo;

// Filter based on configured availability.
const {hostname} = window.location;
if (hostname === 'qa.wandb.ai') {
  MODEL_INFO.models = MODEL_INFO.models.filter(model =>
    model.availableIn.includes('cw-qa')
  );
} else if (hostname === 'wandb.ai' || hostname === 'beta.wandb.ai') {
  MODEL_INFO.models = MODEL_INFO.models.filter(model =>
    model.availableIn.includes('cw-prod')
  );
}

MODEL_INFO.models.forEach((model: Model) => {
  if (model.idHuggingFace) {
    model.urlHuggingFace = `https://huggingface.co/${model.idHuggingFace}`;
  }
});

// Create a mapping from model id to model object.
export const MODEL_INDEX = MODEL_INFO.models.reduce(
  (acc, m) => {
    acc[m.id] = m;
    return acc;
  },
  {} as Record<string, Model>
);

// Create a mapping from idHuggingFace to our internal model id (which is better for URLs)
// TODO: We could alternatively just formalize our ID conversion rule.
export const HUGGINGFACE_ID_TO_MODEL_ID = MODEL_INFO.models.reduce(
  (acc, model) => {
    if (model.idHuggingFace) {
      acc[model.idHuggingFace] = model.id;
    }
    return acc;
  },
  {} as Record<string, string>
);

export const getHostedModels = (): Model[] => {
  return MODEL_INFO.models.filter(
    model => model.status === 'hosted' && !model.isHidden
  );
};

export const getModelsByIds = (modelIds: string[]): Model[] => {
  return modelIds
    .map(id => MODEL_INDEX[id])
    .filter((model): model is Model => model != null);
};
